export default __webpack_public_path__ + "static/media/10-znizki-mobile.b76685cc.jpg";